import { http } from '@/http/index'

async function initializeThread(recipient_alias, recipient_id) {
	return http
		.post(`/messenger/privates/store-empty`, { recipient_alias, recipient_id })
		.then((response) => response.data)
}

export { initializeThread }
